module.exports = __webpack_public_path__ + "static/media/puertas.9995cd5b.jpg";